/* eslint-disable no-template-curly-in-string */
/* eslint-disable prettier/prettier */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
// import { GoogleMap, Marker } from "react-google-maps";
import React from 'react';
import { observer } from 'mobx-react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import { Loader } from "@googlemaps/js-api-loader";

export interface IGoogleSearchState {
    mapApiLoaded: any;
    mapInstance: any;
    mapApi: any;
    places: any;
    scriptLoaded: boolean;
    latLng: any;
    CurrentLocation: any;
}
export interface ICustomModalProps {
    isOpen: any;
    onRequestClose: () => void;
    setSelectedMarker: (marker: any) => void;
    mapApiKey: string;
    address: any;
    activeModalContent: string;
    setActiveModalContent: (data: string) => void;
    setAddressBarDetails: (data: string) => void;
}

/**
 *
 * CustomModal component.
 * @extends {React.PureComponent<ICustomModalProps>}
 */

@observer
export class CustomModal extends React.PureComponent<ICustomModalProps, IGoogleSearchState> {
    constructor(props: ICustomModalProps) {
        super(props);
        this.state = {
            mapApiLoaded: false,
            mapInstance: null,
            mapApi: null,
            places: [],
            scriptLoaded: false,
            latLng: {},
            CurrentLocation: {}
        };
        // console.log("coming here first");
    }

    public componentDidMount() {
      //  this._loadGoogleApi();
        this.closeData();
    }
    public componentDidUpdate(): void {
        const value = this.props.isOpen;
        if(value){
            this._onGoogleMapRender();
        }
    }
    private async _onGoogleMapRender() {
        const loader = new Loader({
            apiKey: "AIzaSyD66_xLEnleDPn7wcYOMwcmQYDKA-XiZsA",
            version: "weekly",
            libraries: ['geometry','places'],
            language: "en",
            region: 'AE'
//            ...additionalOptions
          });
          void loader.load().then(async () => {
            const center = {
                lat: this.state.latLng.lat ? this.state.latLng.lat : 25.2048493,
                lng: this.state.latLng.lng ? this.state.latLng.lng : 55.2707828
                };

            const map = new google.maps.Map(document.getElementById('map-header') as HTMLElement, {
                center,
                zoom: 13,
                disableDefaultUI: true,
                // add back fullscreen, streetview, zoom
                zoomControl: true
            });
            const marker = new google.maps.Marker({
                map,
                draggable: true,
                anchorPoint: new google.maps.Point(0, -29)
            });
            const input = document.getElementById('pac-input-header') as HTMLInputElement;
            // Location bounds start
            // Base64 encoded polylines for Dubai and Hatta zones
            const dubaiZonePolyline = "c35xeUNtYHpwSWpBZUdkQGNBbkBhQXhDZ0J8QUFgQkh+R25BbkdmQHJTakV+WmhWaE9oQ25BaUlucUFraUFQaUBuR3VHcEd5akB3RnlmQGlca3VAYm5AaV9DfEBjQmZGZ1RsQ2FLaGFAX3pBeENjQlx1QFlXVWtAQWVAZEVvT0JfQGRIe1ZGa0B+ckhzZVhiQWBAakRIYUNpTGx0Q3lpS3BzRntxQFJbakBEekBbZkBQakVpQFJQWD9gQXNAZEN1QHBAVmRZc0RqQXdAZUBGbkFEZUl3QXxPeEBuaEp3a0F4WGNDYGhIb31AemBGfkFsfEByQHxsQHhCYl9BfUFgZ11jd0l8fU15fkJ+akB4ZUJgbEZkbVd8X0hkaUd+X0Jwd0R2akR8emNAa19GanhYdWBoQGh0YUBleERkZk9uQHxBY0BsQ2RFYERpekB4fEV1UXpsQHV5SGZwTWV8Um9rVH1lfkBzbHxA";
            const hattaZonePolyline = "aXJ4dkN9cGR1SXpiQnxNdkN+QWREbEF8Q3xAbEV0QGpFTnxBQ2BCSWZFX0BgQld6QVtkXmJEZmxAa3dAYGdBYW1EbG9AYX1AZFBlWHJKYUxwSWJJaGlCeGdDYHRBeEdiX0JuV2JfQ3ZBeF5tZEVvX0hpaFB1ekthXA==";

            // Function to decode a polyline string into a Google Maps LatLng array
            function decodePolyline(encoded: string): google.maps.LatLng[] {
                return google.maps.geometry.encoding.decodePath(encoded);
            }

            // Decoding the encoded polylines
            const dubaiCoords = decodePolyline(atob(dubaiZonePolyline));
            const hattaCoords = decodePolyline(atob(hattaZonePolyline));

            // Creating polygons from the decoded coordinates
            const dubaiPolygon = new google.maps.Polygon({paths: dubaiCoords});
            const hattaPolygon = new google.maps.Polygon({paths: hattaCoords});
            // Location bounds end
            const options = {
                fields: ['formatted_address', 'geometry', 'name'],
                strictBounds: false
            };
            const autocomplete = new google.maps.places.Autocomplete(input, options);
            autocomplete.bindTo('bounds', map);
            const infowindow = new google.maps.InfoWindow();
            const infowindowContent = document.getElementById('infowindow-content-header')as HTMLElement;
            infowindow.setContent(infowindowContent);
            const geocoder = new google.maps.Geocoder();


            // Common function to move user to its current location if in dubai bounds or move pin to dubai
            const moveToCurrentLocation = (lat: number, lng: number) => {
                const newmapser =  new google.maps.LatLng(lat, lng);
                // Checking if the point is within Dubai or Hatta polygons
                if (google.maps.geometry.poly.containsLocation(newmapser, dubaiPolygon) || google.maps.geometry.poly.containsLocation(newmapser, hattaPolygon)){
                    const latLng = new google.maps.LatLng(lat, lng);
                    void geocoder.geocode({ location: latLng }, (results : any, status : any) => {
                        if (status === 'OK' && results[0]) {
                            this.setMapPlaceDetails(results[0].formatted_address, results[0].name);
                                if (results[0].geometry.viewport) {
                                    map.fitBounds(results[0].geometry.viewport);
                                } else {
                                    map.setCenter(results[0].geometry.location);
                                    map.setZoom(17);
                                }
                                marker.setPosition(results[0].geometry.location);
                                marker.setVisible(true);
                                const mapData = {
                                    lat: results[0].geometry.location.lat(),
                                    lng: results[0].geometry.location.lng(),
                                    address_name: results[0].formatted_address,
                                    name: results[0].name
                                };
                                this.props.setSelectedMarker(mapData);
                                infowindow.open(map, marker);
                        } else {
                        console.error(`Geocoder failed due to: ${status}`);
                        }
                    });
                } else {
                    const latLng = new google.maps.LatLng(25.2048493, 55.2707828);
                    void geocoder.geocode({ location: latLng }, (results : any, status : any) => {
                        if (status === 'OK' && results[0]) {
                            this.setMapPlaceDetails(results[0].formatted_address, results[0].name);
                                if (results[0].geometry.viewport) {
                                    map.fitBounds(results[0].geometry.viewport);
                                } else {
                                    map.setCenter(results[0].geometry.location);
                                    map.setZoom(17);
                                }
                                marker.setPosition(results[0].geometry.location);
                                marker.setVisible(true);
                                const mapData = {
                                    lat: results[0].geometry.location.lat(),
                                    lng: results[0].geometry.location.lng(),
                                    address_name: results[0].formatted_address,
                                    name: results[0].name
                                };
                                this.props.setSelectedMarker(mapData);
                                infowindow.open(map, marker);
                        } else {
                        console.error(`Geocoder failed due to: ${status}`);
                        }
                    });
                }
            };
            //

            // Set current location on load
            if(this.state.latLng.lat && this.state.latLng.lng){
                moveToCurrentLocation(this.state.latLng.lat, this.state.latLng.lng);
            }

            // Search map event
            autocomplete.addListener('place_changed', () => {
                marker.setVisible(false);
                const place = autocomplete.getPlace();
                // Location check starts
                const latttituede = place.geometry?.location?.lat() || 0;
                const longitutude = place.geometry?.location?.lng();
                const newmapser =  new google.maps.LatLng(latttituede, longitutude);

                // Checking if the point is within Dubai or Hatta polygons
                if (google.maps.geometry.poly.containsLocation(newmapser, dubaiPolygon) || google.maps.geometry.poly.containsLocation(newmapser, hattaPolygon)) {
                    this.setMapPlaceDetails(place.formatted_address, place.name);
                    if (!place.geometry || !place.geometry.location) {
                        // User entered the name of a Place that was not suggested and
                        // pressed the Enter key, or the Place Details request failed.
                        window.alert(`No details available for input: '${place.name}'`);
                        return;
                    }
                    // If the place has a geometry, then present it on a map.
                    if (place.geometry.viewport) {
                        map.fitBounds(place.geometry.viewport);
                    } else {
                        map.setCenter(place.geometry.location);
                        map.setZoom(17);
                    }
                    marker.setPosition(place.geometry.location);
                    marker.setVisible(true);

                    this.props.setSelectedMarker({
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                        address_name: place?.formatted_address,
                        name: place?.name});
                    infowindow.open(map, marker);
                } else {
                    // The marker is outside the bounds of Dubai city, snap the marker position to the nearest boundary
                    moveToCurrentLocation(this.state.CurrentLocation.lat, this.state.CurrentLocation.lng);
                    alert('Delivery is not available at this location');
                }

            });

            // Marker dragged event
            google.maps.event.addListener(marker, 'dragend', () => {
            marker.setVisible(false);
            const latLng = marker.getPosition();
            void geocoder.geocode({ location: latLng }, (results:any, status:any) => {
                if (status === 'OK' && results[0]) {
                    const newmapser =  new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                    if (google.maps.geometry.poly.containsLocation(newmapser, dubaiPolygon) || google.maps.geometry.poly.containsLocation(newmapser, hattaPolygon)){
                        this.setMapPlaceDetails(results[0].formatted_address, results[0].name);
                        if (results[0].geometry.viewport) {
                            map.fitBounds(results[0].geometry.viewport);
                        } else {
                            map.setCenter(results[0].geometry.location);
                            map.setZoom(17);
                        }
                        marker.setPosition(results[0].geometry.location);
                        marker.setVisible(true);
                        this.props.setSelectedMarker({
                            lat: results[0].geometry.location.lat(),
                            lng: results[0].geometry.location.lng(),
                            address_name: results[0]?.formatted_address,
                            name: results[0]?.name
                        });
                        infowindow.open(map, marker);
                    } else{
                        // The marker is outside the bounds of Dubai city, snap the marker position to the nearest boundary
                        moveToCurrentLocation(this.state.CurrentLocation.lat, this.state.CurrentLocation.lng);
                        alert('Delivery is not available at this location');
                    }

                } else {
                    console.error(`Geocoder failed due to: ${status}`);
                }
                });
            });

            // Move to current location event
            const locationButton = document.getElementById('move-to-current-location-header') as HTMLInputElement;
            locationButton.addEventListener("click", () => {
                moveToCurrentLocation(this.state.CurrentLocation.lat, this.state.CurrentLocation.lng);
            });
          });
    }

    private async getMapDefaultProps() {
        // Get the user's current location using the browser's geolocation API
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    this.setState({latLng: {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    }});
                    this.setState({CurrentLocation: {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    }});
                },
                error => {
                    console.error('Error getting user location:', error);
                }
            );
        } else {
            this.setState({latLng: {
                lat: 25.2048493,
                lng: 55.2707828
            }});
        }
    }

    private setMapPlaceDetails(formatted_address :any, name:any){
        const placeAddressElement = document.getElementById('place-address-header')as HTMLElement;
        if (placeAddressElement) {
            const addressText: string = formatted_address || '';
            placeAddressElement.textContent = addressText;
        }
        const placeNameElement = document.getElementById('place-name-header')as HTMLElement;
        if (placeNameElement) {
            const nameText: string = name || '';
            placeNameElement.textContent = nameText;
        }
    }

    // private _loadGoogleApi() {
    //     const mapsURL = `https://maps.googleapis.com/maps/api/js?key=AIzaSyD66_xLEnleDPn7wcYOMwcmQYDKA-XiZsA&libraries=geometry,places&language=no&region=NO&v=quarterly`;
    //     //const mapsURL = `https://maps.googleapis.com/maps/api/js?key=AIzaSyD66_xLEnleDPn7wcYOMwcmQYDKA-XiZsA`;
    //     // var scriptser =
    //     //     '<script>(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({key: "AIzaSyB41DRUbKWJHPxaFjMAwdrzWzbVKartNGg", v: "weekly"});</script>';
    //     const scripts = document.getElementsByTagName('script');
    //     // Go through existing script tags, and return google maps api tag when found.
    //     for (let i = 0; i < scripts.length; i++) {
    //         if (scripts[i].src.indexOf(mapsURL) === 0) {
    //             return scripts[i];
    //         }
    //     }
    //     const googleMapScript = document.createElement('script');
    //     googleMapScript.src = mapsURL;
    //     googleMapScript.async = true;
    //     googleMapScript.defer = true;
    //     window.document.body.appendChild(googleMapScript);
    //     return null;
    // }
    public renderAnyReactComponent(text: any) {
        return <div>{text}</div>;
    }
    // private _updateStateScript() {
    //      void this.initMap();
    //     console.log("its updated");
    //   //  this.setState({scriptLoaded: true});
    // }
    public apiHasLoaded = (map: any, maps: any) => {
        this.setState({
            mapApiLoaded: true,
            mapInstance: map,
            mapApi: maps
        });
    };
    public closeData(){
        void this.getMapDefaultProps();
        this.setState({mapApiLoaded: true});
    }
    public render(): JSX.Element {
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.onRequestClose} modalClassName='google-map-modal global-map'>
                <div className='row localy-address'>
                <ModalHeader>
                    {this.props.address && this.props.address.length > 0 && (
                        <button onClick={() => {this.props.setActiveModalContent('address');}} className='deliver-here-button1'>
                            <span>
                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_2217_16867)">
                                    <mask id="mask0_2217_16867" maskUnits="userSpaceOnUse" x="0" y="0" width="10" height="10">
                                    <path d="M10 0H0V10H10V0Z" fill="white"/>
                                    </mask>
                                    <g mask="url(#mask0_2217_16867)">
                                    <path d="M7.25098 9.64319L2.85812 5.25033C2.82396 5.21827 2.79673 5.17954 2.77811 5.13654C2.7595 5.09354 2.7499 5.04719 2.7499 5.00033C2.7499 4.95348 2.7595 4.90712 2.77811 4.86412C2.79673 4.82112 2.82396 4.78239 2.85812 4.75033L7.25098 0.357471" stroke="#610FD1" strokeLinecap="round" strokeLinejoin="round"/>
                                    </g>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_2217_16867">
                                    <rect width="10" height="10" fill="white"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                                Back to Address
                            </span>
                        </button>
                    )}
                    <div className='row'>
                    </div>
                    <h1 className='delivery-title'>Delivery location</h1>
                    <h3 className='delivery-subtitle'>Search or move the pin to match the location on map</h3>
                </ModalHeader>
                <ModalBody>
                    <div style={{ height: '468px', width: '100%' }}>
                    <div id="pac-test-container">
                            <div className='input-wrapper-map'>
                                <input id="pac-input-header" className="location-search-input" type="text" placeholder="Search for area/locality" />
                                <a id='move-to-current-location-header'><img src='https://files-eu-prod.cms.commerce.dynamics.com/cms/api/vnnhvggtsx/binary/MD3dq' ></img></a>
                            </div>
                        </div>
                        <div id="infowindow-content-header">
                        <span id="place-name-header" className="place-name title"></span><br />
                        <span className="place-address" id="place-address-header"></span>
                        </div>
                       <div id='map-header' style={{ height: '400px', width: '100%' }}></div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button onClick={this.props.onRequestClose} className='deliver-here-button'>
                        <span>Deliver Here</span>
                    </button>
                </ModalFooter>
                </div>
            </Modal>
        );
    }
}